import React, { useState, useEffect } from 'react';
import information from '../../assets/images/mo_icon/mo_info.svg';
import home from '../../assets/images/mo_icon/mo_home.svg';
import notification from "../../assets/images/all/notification_1.svg";
import infoIcon2 from "../../assets/images/mo_icon/mo_info_active.svg";
import notifyIcon2 from "../../assets/images/mo_icon/NOTIFICATION BELL01.svg";
import homeIcon2 from "../../assets/images/mo_icon/mo_home_active.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import CoachMarkPopup from '../Modal/CoachMarkPopup';

const MobileFooter = () => {
  const [activeClass, setActiveClass] = useState("Home");
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const device = useSelector(state => state.CommonConfig.device_type);
  const location = useLocation();
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.paginationData.currentStep)


  useEffect(() => {

    if (location.pathname === "/game/AllGames") {
      setActiveClass("Home");
    } else if (location.pathname === "/information") {
      setActiveClass("Information");
    } else if (location.pathname === "/notification") {
      setActiveClass("Notification");
    } else {

      setActiveClass(location.pathname.substring(1).charAt(0).toUpperCase() + location.pathname.substring(2));
    }
  }, [location.pathname]);

  const icons = [
    { src: notification, alt: 'Notification', popup: "Notification", srcActive: notifyIcon2 },
    { src: home, alt: 'Home', popup: "Home", srcActive: homeIcon2 },
    { src: information, alt: 'Information', popup: "Information", srcActive: infoIcon2 },
  ];

  const handleIconClick = (popupComponent) => {
    setActiveClass(popupComponent);
    navigate(popupComponent === "Home" ? "/" : "/" + popupComponent.toLowerCase());
  }


  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024); // Adjust breakpoint for mobile
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={`mo_footer ${device === "Desktop" ? "desktop" : "mobile"} `} style={{
      bottom: "0",
      zIndex:
        [9, 10, 11, 12].includes(currentStep)
          ? 9
          : currentStep === 4
            ? 0
            : isMobile && (currentStep === 0 || currentStep === 1 || currentStep === 2 || currentStep === 3)
              ? -1
              : 3,
    }}>
      <ul>
        {icons.map((icon, index) => (
          <li key={index} className={`footer-menu custom-tooltip-wrapper ${icon.popup === activeClass ? "active" : ""} 
                    ${(isMobile ? currentStep === 9 : false) && index === 1 ? "highlighted home" : ""
            } ${(isMobile ? currentStep === 10 : false) && index === 2 ? "highlighted home info" : ""
            }
                      ${(isMobile ? currentStep === 11 : false) && index === 0 ? "highlighted home notify" : ""
            }
                      `}



            onClick={() => handleIconClick(icon.popup)}>
            <img src={icon.popup === activeClass ? icon.srcActive : icon.src} />
            {icon.src === notification ? <div className='mo_notify_count'>{user_balance.countNotif} </div> : ""}
            {(isMobile && currentStep === 9) && <CoachMarkPopup />}


            {(isMobile && currentStep === 10) && <CoachMarkPopup />}


            {(isMobile && currentStep === 11) && <CoachMarkPopup />}


          </li>

        ))}

      </ul>

      {/* {(isMobile && currentStep === 1) && (
        <div className="custom-overlay-mo-footer" style={{
          height: window.innerWidth <= 1024 ? "96%" : "auto"
        }}></div>
      )}
      {(isMobile && currentStep === 9) && (
        <div className="custom-overlay" style={{
          height: window.innerWidth <= 1024 ? "19%" : "auto"
        }}></div>
      )}


      {(isMobile && currentStep === 10) && (
        <div className="custom-overlay"></div>
      )} */}


      {(isMobile && (currentStep === 11 || currentStep === 9 || currentStep === 10)) && (
        <div className="custom-overlay"></div>
      )}

      {(isMobile && currentStep === 0) && (
        <div className="custom-overlay-mo-footer" style={{
          height: window.innerWidth <= 1024 ? "93%" : "auto"
        }}></div>
      )}

      {(isMobile && currentStep === 1) && (
        <div className="custom-overlay-mo-footer" style={{
          height: window.innerWidth <= 1024 ? "93%" : "auto"
        }}></div>
      )}

      {(isMobile && currentStep === 2) && (
        <div className="custom-overlay-mo-footer" style={{
          height: window.innerWidth <= 1024 ? "93%" : "auto"
        }}></div>
      )}

      {(isMobile && currentStep === 3) && (
        <div className="custom-overlay-mo-footer" style={{ height: "93%" }}></div>
      )}



    </div>
  );
};

export default MobileFooter;
